export default __webpack_public_path__ + "static/嘉宾头像_倪光南-fee24926622c04e87651acecc2edb59f.png";